module.exports = __webpack_public_path__ + "img/file_type_w.c7e7589.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/AISmart/file_type_w.png
// module id = R1tW
// module chunks = 12 13 14 17 26